(function handlerFullImageViewerTemplateForm() {
  'use strict';

  /**
     * Fills the inputs of the Full Image Viewer Schedule Tour form template with the provided data.
     * Iterates over each field defined in fieldsMap and updates the corresponding DOM element.
     * @param {Event} event - The event containing the form data.
    */
  const fillFullImageViewerTemplateInputs = (event) => {
    const formData = event.detail;
    const fivFormTemplate = document.querySelector('[data-component="full-image-viewer-scheduleTour-template"]');

    const fieldsMap = {
      name: '#Name',
      emailAddress: '#MailAddress',
      phoneNumber: '#UserPhoneNumber',
      postalCode: '#UserPostalCode',
      preferredContactMethod: '#nhs-contact-method',
      sendAlerts: '#SendAlerts',
    };

    /**
     * Use Object.keys(fieldsMap).forEach to iterate over each field defined in fieldsMap.
     * - For each field:
     *   - Selects the corresponding element in the DOM.
     *   - Checks if the corresponding value in formData is not undefined.
     *   - Sets the field value (element.checked or element.value).
    */
    Object.keys(fieldsMap).forEach((key) => {
      const element = fivFormTemplate.content.querySelector(fieldsMap[key]);
      if (element) {
        if (typeof formData[key] !== 'undefined') {
          if (element.type === 'checkbox') {
            element.checked = formData[key];
          } else {
            element.value = formData[key];
          }
        }
      }
    });

    /**
     * Additionally, handles the special case for the livesOutside field:
     * - If livesOutside is not null:
     *   - Selects the international gallery checkbox and updates its checked property.
     *   - Selects the postal code field and:
     *     - Clears the postal code value if livesOutside is true.
     *     - Disables the postal code field if livesOutside is true.
    */
    if (formData.livesOutside != null) {
      const livesOutside = fivFormTemplate.content.querySelector('#international-gallery');
      if (livesOutside) {
        livesOutside.checked = formData.livesOutside;
      }
      const postalCode = fivFormTemplate.content.querySelector('#UserPostalCode');
      if (postalCode) {
        if (formData.livesOutside) {
          postalCode.value = '';
        }
        postalCode.disabled = formData.livesOutside;
      }
    }
  };

  document.body.addEventListener('onLeadPosted', fillFullImageViewerTemplateInputs);
}());